import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { CityComponent } from './city.component';
import { CityRoutingModule } from './city-routing.module';


import { ProductViewerComponent } from './product_viewer/product-viewer.component';
import { AboutCityComponent } from './about_city/about-city.component';
import { CityService } from '../services/city.service';
import { FilterBarComponent } from './filter-bar/filter-bar.component';
/*import { UsefulInformationComponent } from './useful_information/useful-information.component';
import { SpotlightProductComponent } from './spotlight_product/spotlight-product.component';*/

@NgModule({
  imports: [
    SharedModule,
    CityRoutingModule
  ],
  declarations: [
    CityComponent,
    ProductViewerComponent,
    AboutCityComponent,
    FilterBarComponent
    /*UsefulInformationComponent,
    SpotlightProductComponent*/
  ],
  providers: [
    CityService
  ]
})
export class CityModule { }
